import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {editFirmaStart} from '../../store/actions/firma-edit.actions';
import {loadBranchenStart} from '../../store/actions/branche.actions';
import {loadFirmaZeitenStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFirmaZeiten.actions';
import {deleteFirmaZeitStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-del.actions';
import {editFirmaZeitenStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-edit.actions';
import {loadFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFeiertage.actions';
import {addFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/feiertage-add.actions';
import * as moment from 'moment';
import {editFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/feiertage-edit.actions';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  firmaZeitId: number;
  datum: Date;
  bez: string;
}

@Component({
  selector: 'app-feiertage-formdialog',
  templateUrl: './feiertage-formdialog.component.html',
  styleUrls: ['./feiertage-formdialog.component.scss']
})


export class FeiertageFormdialogComponent implements OnInit{

  constructor(public dialogRef: MatDialogRef<FeiertageFormdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private store: Store<{ mitarbeiterverwaltung: State }>)
  {
    dialogRef.disableClose = true;

    this.feiertagForm.patchValue({
      datum: data.datum,
      bez: data.bez,
      firmaZeitId: data.firmaZeitId,
      id: data.id,
    });
  }

  public feiertagForm = new FormGroup({
    datum: new FormControl('', [Validators.required]),
    bez: new FormControl(''),
    id: new FormControl(''),
    firmaZeitId: new FormControl('')
  });


  public handleSubmitClick(): void{
    this.feiertagForm.value.datum = this.wandler(this.feiertagForm.value.datum);

    if(this.feiertagForm.value.id){
      this.store.dispatch(editFeiertageStart({item: this.feiertagForm.value}));
    }
    else{
      this.store.dispatch(addFeiertageStart({item: this.feiertagForm.value}));
    }


    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public ngOnInit(): void {
    // this.store.dispatch(loadFeiertageStart({firmaZeitId: this.data.zeitId}));
  }

  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }
}
